import type {
  AgentSelection,
  ActionType,
  ChatPendingMessageRemovedAction,
  ChatPendingMessageSetAction,
  Message,
  MessageKind,
  MessageAttachment,
  ModelSelection,
  PendingMessageKind,
} from '@microsoft/agent-host-protocol'

export type ContributedInstructionsMetadata = ReadonlyArray<{
  readonly kind: 'personal' | 'repository' | 'organization'
  readonly label?: string
  readonly ownerUrl?: string
}>

const ACTION_PENDING_MESSAGE_SET = 'chat/pendingMessageSet' as ActionType.ChatPendingMessageSet
const ACTION_PENDING_MESSAGE_REMOVED = 'chat/pendingMessageRemoved' as ActionType.ChatPendingMessageRemoved
const MESSAGE_KIND_USER = 'user' as MessageKind.User

/**
 * `Message._meta` key the host reads as the prompt sent to the model in place
 * of `text`. `text` stays the prompt the transcript shows.
 */
export const MODEL_TEXT_META_KEY = 'copilot.modelText'

export function buildUserMessage(
  text: string,
  attachments?: MessageAttachment[],
  model?: ModelSelection,
  agent?: AgentSelection,
  contributedInstructions?: ContributedInstructionsMetadata,
  modelText?: string,
): Message {
  const meta = {
    ...(contributedInstructions !== undefined ? {'github.contributedInstructions': contributedInstructions} : {}),
    ...(modelText ? {[MODEL_TEXT_META_KEY]: modelText} : {}),
  }
  return {
    text,
    origin: {kind: MESSAGE_KIND_USER},
    ...(attachments && attachments.length > 0 ? {attachments} : {}),
    ...(model ? {model} : {}),
    ...(agent ? {agent} : {}),
    ...(Object.keys(meta).length > 0 ? {_meta: meta} : {}),
  }
}

export function buildPendingMessageSetAction(
  kind: PendingMessageKind,
  text: string,
  attachments?: MessageAttachment[],
  model?: ModelSelection,
  id: string = crypto.randomUUID(),
  agent?: AgentSelection,
  contributedInstructions?: ContributedInstructionsMetadata,
): ChatPendingMessageSetAction {
  return {
    type: ACTION_PENDING_MESSAGE_SET,
    kind,
    id,
    message: buildUserMessage(text, attachments, model, agent, contributedInstructions),
  }
}

export function buildPendingMessageRemovedAction(
  kind: PendingMessageKind,
  id: string,
): ChatPendingMessageRemovedAction {
  return {
    type: ACTION_PENDING_MESSAGE_REMOVED,
    kind,
    id,
  }
}
